<template>
  <div id="say-trip">
    <TravelSpecialistCard full-width @open="openSpecialistModal" />
    <main v-if="ready">
      <Header></Header>
      <SectionWhy></SectionWhy>
      <Overview></Overview>
      <DayList></DayList>
      <Pricing bookingType="PCM"></Pricing>
      <NextSteps bookingType="PCM"></NextSteps>
      <CarbonNeutral></CarbonNeutral>
      <FAQs></FAQs>
      <Footer></Footer>

      <TravelSpecialistModal :show="showModal" @close="closeModal" />

    </main>
    <Transition>
        <BlockUI v-if="!ready"></BlockUI>
    </Transition>
    <VamoosButton v-if="isUser && dayList.length"/>
  </div>
</template>

<script>
import Header from '@/components/itinerary/Header.vue';
import SectionWhy from '@/components/itinerary/SectionWhy.vue';
import Overview from '@/components/itinerary/Overview.vue';
import DayList from '@/components/itinerary/DayList.vue';
import Pricing from '@/components/itinerary/Pricing.vue';
import NextSteps from '@/components/itinerary/NextSteps.vue';
import CarbonNeutral from '@/components/itinerary/CarbonNeutral.vue';
import FAQs from '@/components/itinerary/FAQs.vue';
import BlockUI from '@/components/tools/BlockUI.vue';
import Footer from '@/components/tools/Footer.vue';
import VamoosButton from '@/components/tools/VamoosButton.vue';
import TravelSpecialistCard from '@/components/itinerary/TravelSpecialistCard.vue';
import TravelSpecialistModal from '@/components/itinerary/TravelSpecialistModal.vue';
import BaseItineraryPage from '@/components/pages/BaseItineraryPage.vue';
import '@/assets/css/main.scss';
const api = window.api;
//const s3 = process.env.VUE_APP_S3;
export default {
  name: 'SayTrip',
  extends: BaseItineraryPage,
  data() {
    return {
      hidePrices: false
    }
  },
  computed: {
    dayList() {
      return this.$store.getters.dayList;
    },
  },
  async mounted() {
    api.get('/api/tpsql/trip_cover', this.$route.query, null, (result) => {
      this.$store.commit('setNames', {values: result, isPCM: true});
    });
    api.get('/api/tpsql/replace_notes', this.$route.query, null, (result) => {
      this.$store.commit('setReplaceNotes', result);
    });
    api.get('/api/tpsql/trip_seller_db', this.$route.query, null, (r) => {
        if (r) {
          this.$store.commit('setSeller', r);
        }
    });
    api.get('/api/tpsql/pcm_client_image', this.$route.query, null, (result) => {
        this.$store.commit('setClientImage', result);
    });
    let res = await api.get('/api/tpsql/booking', this.$route.query);
    if (res) {
      this.$store.commit('setBooking', res);
      this.$store.commit('setDateView', res[0].ANALYSIS2);
      this.$store.commit('setAgent', res?.[0]?.agent);
      this.$store.commit('setQuery', this.$route.query);
      let hidePrices = res && res[0] && res[0].HidePrices;
      if (hidePrices) hidePrices = hidePrices.replace(/ /g, '');
      if (hidePrices) {
        this.hidePrices = hidePrices;
        this.$store.commit('setHidePrices', this.hidePrices);
      } else {
        api.get('/api/tpsql/trip_prices', this.$route.query, null, (result) => {
          this.$store.commit('setPrices', result);
        });
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
    api.get('/api/tpsql/pcm_flights', this.$route.query, null, (result) => {
      this.$store.commit('setFlights', result);
    });
    api.get('/api/tpsql/language_notes', this.$route.query, null, (r) => {
      this.$store.commit('setLanguageNotes', r);
      setTimeout(() => {
        this.loadingNotes = false;
      }, 1000);
    });
  },
  components: {
    Header,
    SectionWhy,
    Overview,
    DayList,
    Pricing,
    NextSteps,
    CarbonNeutral,
    FAQs,
    BlockUI,
    Footer,
    VamoosButton,
    TravelSpecialistCard,
    TravelSpecialistModal,
  }
}
</script>

<style scoped>
.trip-body {
  overflow: scroll;
}

.v-leave-active {
  transition: opacity 1s ease;
}


.v-leave-to {
  opacity: 0;
}
</style>
